import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_MODAL_EDIT_SUBJECT_OPEN = "CE_MODAL_EDIT_SUBJECT_OPEN";
export const ceModalEditSubjectOpen = (clientContentID) => ({
  type: CE_MODAL_EDIT_SUBJECT_OPEN,
  client_content_id: clientContentID,
});

export const CE_MODAL_EDIT_SUBJECT_SAVE = "CE_MODAL_EDIT_SUBJECT_SAVE";
export const ceModalEditSubjectSave = () => ({
  type: CE_MODAL_EDIT_SUBJECT_SAVE,
});

export const ceModalEditSubjectCancel = () => ({
  type: CE_MODAL_CLOSE,
});
